function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { useAction } from 'hooks';
import Modal from 'components/Modal';
import Button from 'components/Form/Button';
import App from 'modules/App';
import messages from '../../messages';
import * as constants from '../../constants';
const WaitForEnrollAcceptedModal = ({ headerMessage, infoMessage, onBack })=>{
    const openModalId = useSelector(App.selectors.modal);
    const closeModal = useAction(App.actions.closeModal);
    const onClose = useCallback(()=>{
        closeModal();
        onBack();
    }, []);
    return /*#__PURE__*/ _jsxs(Modal, {
        modalId: constants.WAIT_FOR_ENROLL_ACCEPTED_MODAL,
        openModalId: openModalId,
        styleModifier: "md",
        headerMessage: headerMessage,
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "modal__info",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, infoMessage))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "modal__actions",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: messages.buttons.close,
                    className: "btn--block btn--filled",
                    onClick: onClose
                })
            })
        ]
    });
};
export default WaitForEnrollAcceptedModal;
